import { queryOptions, useQuery } from '@tanstack/react-query';

import { collectionsApi } from '../api/collections-api';

import { collectionKeys } from './collection-keys';

export function collectionQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: collectionKeys.detail(storeId, id),
    queryFn: () => collectionsApi.get(storeId, id),
  });
}

export function useCollection(storeId: string, id: string) {
  return useQuery(collectionQueryOptions(storeId, id));
}

/** The materialised product list, in position order. */
export function collectionProductsQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: collectionKeys.products(storeId, id),
    queryFn: () => collectionsApi.products(storeId, id),
  });
}

export function useCollectionProducts(storeId: string, id: string) {
  return useQuery(collectionProductsQueryOptions(storeId, id));
}
